@use '../../styling/colors.scss' as *;
@use '../../styling/typography.scss' as *;

/* stylelint-disable */
:export {
  colorpass: $color-secondary-green;
  colorfail: $color-primary-red-hover;
  colorincomplete: $color-primary-purple;
  colorcancelled: $color-grey-C;
  colorerror: $color-warning-orange;
}

/* stylelint-enable */

.ChartTitle {
  margin-bottom: 24px;
}

.ChartContainer {
  display: flex;
  justify-content: center;
}

.ChartWrapper {
  width: 160px;
  height: 120px;
  position: relative;
  margin-left: -24px; /* Adjusted to align the chart with the title */
}

.StatusContainer {
  @extend %font-family-primary;
  @extend %font-weight-semibold;

  display: flex;
  flex-direction: column;
  row-gap: 8px;

  .StatusItem {
    display: inline-flex;
    align-items: center;
    column-gap: 8px;
  }

  .StatusLabel {
    flex-grow: 1;
    white-space: nowrap;
  }
}
